import { WebP } from '/src/components/WebP';
import { RenderTriggerText } from '/src/features/goals/components/RenderTriggerText';
import { getGoalTriggerMetadata } from '/src/features/goals/triggerMetadata';
import { resolveTriggerKind } from '/src/features/goals/utils';

export function GoalTriggerList({ triggers, filterDeleted }) {
  const triggerList = Array.isArray(triggers) ? triggers.filter((trigger) => !filterDeleted || !trigger.deletedAt) : [];

  return (
    <div className="w-[387px] max-w-[calc(100vw-32px)] text-left leading-none px-5 pt-3.75 pb-[26px]">
      <div className="font-bold text-xs pb-3.75">Triggers</div>
      <ul className="w-full max-h-[476px] overflow-x-auto scrollbar-thin scrollbar-track-transparent scrollbar-thumb-cadet-blue-500 scrollbar-thumb-rounded">
        {triggerList.map((trigger, index) => {
          const triggerMetadata = getGoalTriggerMetadata(resolveTriggerKind(trigger));
          const isDeleted = !!trigger?.deletedAt && trigger.deletedAt > 0;

          return (
            <li
              className="border-b-5 border-black last:border-none"
              key={trigger?.id ?? `${trigger?.type ?? 'other'}-${index}`}
            >
              <div className="bg-mako-500 rounded-md p-2.5 flex h-[60px]">
                <div className="h-10 w-10 rounded bg-white bg-opacity-10 flex items-center justify-center">
                  <WebP
                    className="w-[25px]"
                    webp={triggerMetadata?.miniWebp ?? triggerMetadata.webp}
                    fallback={triggerMetadata?.miniPng ?? triggerMetadata.png}
                    width="25"
                    alt={`trigger type ${trigger?.type?.toLowerCase?.() ?? 'other'}`}
                  />
                </div>
                <div className="flex items-center flex-1 overflow-hidden pl-3 pr-5">
                  <div className="flex flex-col overflow-hidden text-left">
                    <RenderTriggerText trigger={trigger} isDeleted={isDeleted} />
                  </div>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
